import { render, staticRenderFns } from "./TemplatePicker.vue?vue&type=template&id=10fdb021&scoped=true&"
import script from "./TemplatePicker.vue?vue&type=script&lang=js&"
export * from "./TemplatePicker.vue?vue&type=script&lang=js&"
import style0 from "./TemplatePicker.vue?vue&type=style&index=0&id=10fdb021&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fdb021",
  null
  
)

export default component.exports